<div class="footer flex flex-col gap-8 pt-12 pb-3">
  <div class="top__footer container mx-auto grid sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-4 grid-cols-1 gap-4">
    <!-- Small screens logo -->
    <div class="small__screen flex items-center gap-4">
      <div class="logo__icon" inlineSVG="nav/logo.svg"></div>
      <p class="logo__name" translate>Posty 5</p>
    </div>
    <!-- First Col -->
    <div class="flex flex-col gap-6">
      <div class="large__screen flex items-center gap-4">
        <div class="logo__icon" inlineSVG="nav/logo.svg"></div>
        <p class="logo__name" translate>Posty 5</p>
      </div>

      <div class="flex  gap-4 download__methods">
        <a href="https://chromewebstore.google.com/detail/url-shortener-posty-5/dcmfkpoeaeplhifahkplmjbbajnkckkc?hl={{i18nService.language}}"
          class="primary__btn   text-center inline-flex items-center me-2 mb-2 ">
          <div inlineSVG="footer/chrome-extensions.svg"></div>
          {{'URL Shorterner'|translate}}
        </a>
      </div>
    </div>
    <!-- Second Col -->
    <ul class="footer__links" *ngIf="!pt.isMobile">
      <li>
        <a [routerLink]="['/', i18nService.language, 'seo-tags-extractor']" translate="SEO Extractor"> </a>
      </li>
      <li>
        <a [routerLink]="['/', i18nService.language, 'qr-code-generator']" translate="QR Code Generator"> </a>
      </li>
      <!-- <li>
        <a [routerLink]="['/', i18nService.language, 'whatsapp-message-link-generator']"
          translate="Whatsapp Link Generator">
        </a>
      </li> -->
      <li>
        <a [routerLink]="['/', i18nService.language, 'html-hosting']" translate="HTML Hosting"> </a>
      </li>
    </ul>

    <!-- Third Col -->
    <ul class="footer__links" *ngIf="!pt.isMobile">
      <li>
        <a [routerLink]="['/', i18nService.language, 'crop-photo']" translate="Crop Photos"> </a>
      </li>
      <li>
        <a [routerLink]="['/', i18nService.language, 'url-shortener']" translate="URL Shortener"> </a>
      </li>
      <li>
        <a [routerLink]="['/', i18nService.language, 'contact-us']" translate="Contact Us"> </a>
      </li>
    </ul>
    <!-- Fourth Col -->
    <ul class="footer__links">
      <li>
        <a [routerLink]="['/', i18nService.language, 'about-us']" translate="About Us"> </a>
      </li>
      <li>
        <a [routerLink]="['/', i18nService.language, 'privacy-policy']" translate="Privacy Policy"> </a>
      </li>
      <li>
        <a [routerLink]="['/', i18nService.language, 'usage-agreement']" translate="Usage Agreement"> </a>
      </li>

      <!-- <li>
        <a [routerLink]="['/', i18nService.language, 'partner-earnings']" translate="Partner Earnings"> </a>
      </li> -->
    </ul>
    <!-- Small screens download -->
    <!-- <div class="small__screen flex items-center gap-4 footer__download"> -->
    <!-- <a href="javascript:void" [attr.aria-label]="'Download iOS App' | translate">
        <div inlineSVG="footer/appstore.svg"></div>
      </a>
      <a href="javascript:void" [attr.aria-label]="'Download Android App' | translate">
        <div inlineSVG="footer/googleplay.svg"></div>
      </a> -->
    <!-- </div> -->
    <div class="flex justify-center items-center gap-4 download__methods">
      <!-- <a href="https://chromewebstore.google.com/detail/url-shortener-posty-5/dcmfkpoeaeplhifahkplmjbbajnkckkc?hl={{i18nService.language}}"
        class="primary__btn   text-center inline-flex items-center me-2 mb-2">
        <div inlineSVG="footer/chrome-extensions.svg"></div>
        {{'URL Shorterner'|translate}}
      </a> -->
    </div>
  </div>

  <div class="bottom__footer container mx-auto flex justify-between items-center gap-6">
    <div class="languages flex items-center gap-4" app-footer-languages></div>
    <div class="copyright" translate="All Rights Reserved © 2024"></div>
  </div>
</div>